/** Spécialités formateur — alignées sur les filières Academia (seed / catalogue). */
export const FORMATEUR_SPECIALITE_OPTIONS = [
  'Général',
  'Informatique & Programmation',
  'Développement Web & Mobile',
  'Cybersécurité',
  'Réseaux & Systèmes Informatiques',
  'Transformation Digitale',
  'Intelligence Artificielle & Data',
  'Comptabilité & Gestion',
  'Secrétariat de Direction',
  'Gestion des Ressources Humaines',
  'Gestion de Projets',
  'Marketing Digital & Communication',
  'Infographie & Multimédia',
  'AutoCAD & Dessin Technique',
  'Hôtellerie, Accueil & Services',
  'Entrepreneuriat & Innovation',
  'Éducation Financière',
  'Gouvernance & Leadership',
  'Cybersouveraineté & Défense Numérique',
] as const;

export type FormateurSpecialiteOption = (typeof FORMATEUR_SPECIALITE_OPTIONS)[number];

/** Inclut une valeur legacy si elle n'est plus dans le catalogue. */
export function resolveFormateurSpecialiteOptions(current?: string | null): string[] {
  const trimmed = current?.trim() ?? '';
  if (trimmed && !FORMATEUR_SPECIALITE_OPTIONS.includes(trimmed as FormateurSpecialiteOption)) {
    return [trimmed, ...FORMATEUR_SPECIALITE_OPTIONS];
  }
  return [...FORMATEUR_SPECIALITE_OPTIONS];
}
